import React from 'react';
import classNames from 'classnames';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".form-inline-group__form-control-group__7-33-0 {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n\r\n  .form-inline-group__form-control-group__7-33-0 > button,\r\n  .form-inline-group__form-control-group__7-33-0 > select,\r\n  .form-inline-group__form-control-group__7-33-0 > input,\r\n  .form-inline-group__form-control-group__7-33-0 > a,\r\n  .form-inline-group__form-control-group__7-33-0 > div,\r\n  .form-inline-group__form-control-group__7-33-0 > span {\r\n    margin-right: -1px;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .form-inline-group__form-control-group__7-33-0 > button:first-child, .form-inline-group__form-control-group__7-33-0 > select:first-child, .form-inline-group__form-control-group__7-33-0 > input:first-child, .form-inline-group__form-control-group__7-33-0 > a:first-child, .form-inline-group__form-control-group__7-33-0 > div:first-child, .form-inline-group__form-control-group__7-33-0 > span:first-child {\r\n      border-top-left-radius: 3px;\r\n      border-bottom-left-radius: 3px;\r\n    }\r\n\r\n  .form-inline-group__form-control-group__7-33-0 > button:last-child, .form-inline-group__form-control-group__7-33-0 > select:last-child, .form-inline-group__form-control-group__7-33-0 > input:last-child, .form-inline-group__form-control-group__7-33-0 > a:last-child, .form-inline-group__form-control-group__7-33-0 > div:last-child, .form-inline-group__form-control-group__7-33-0 > span:last-child {\r\n      border-top-right-radius: 3px;\r\n      border-bottom-right-radius: 3px;\r\n      margin-right: 0;\r\n    }\r\n";
var styles = {"form-inline-group":"form-inline-group__form-control-group__7-33-0"};
styleInject(css);

/**
 * FormControlGroup is a wrapper for form elements like buttons, input boxes
 * The main purpose - group elements together on a single line,
 *  and rewrite styling rules like `border-radius`
 *
 * Usage:
 * ```jsx
 * <FormControlGroup className="my_own_class">
 *      <Button>Click</Button>
 *      <Button>Submit</Button>
 * </FormControlGroup>
 * ```
 *
 */

var FormControlGroup = function FormControlGroup(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement("div", {
    className: classNames(styles['form-inline-group'], className)
  }, children);
};

export { FormControlGroup };
